export default "<app-navigator-app></app-navigator-app> \n<router-outlet></router-outlet>\n"